import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Section from '../../Components/Section'
import Loader from '../../Components/Loader'
import Poster from '../../Components/Poster'
import { Helmet } from 'react-helmet'
import Error from '../../Components/Error'
import Message from '../../Components/Message'
import { useHistory } from 'react-router-dom'

const Container = styled.div`
    padding:50px 60px 70px;
    height:calc(100vh - 50px);
    h1{
        font-size:18px;
        padding-left:10px;
    }
    @media screen and (max-width:768px) {
        padding:5px
    }
`
const Form = styled.form`
    margin-bottom: 50px;
    @media screen and (max-width:768px) {
        margin-bottom:20px;
    }
`
const Input = styled.input`
    all:unset;
    width:100%;
    padding:5px 0;
    font-size:28px;
    background:rgba(255,255,255,0.1);
    line-height:28px;
    text-indent:15px;
    @media screen and (max-width:768px) {
        font-size:22px;
        line-height:25px;
        margin-top:10px;
        text-indent:15px;
    }
`

const SearchPresenter = ({ loading, error, searchTerm, searchResult, movieResult, tvResult, onSubmit, onChange }) => {
    const history = useHistory()
    const term = history.location.pathname.split('/')[2]
    return (loading ? <Loader /> : error ? <Error data={'Error!'} /> :
        < Container >
            <Helmet>
                <title>
                    Search | Maflix
                </title>
            </Helmet>
            <Form onSubmit={onSubmit} >
                <Input onChange={onChange} value={searchTerm} placeholder='Search Movies or TV Shows' />
            </Form>
            {loading ? <Loader /> : <>
                {movieResult && movieResult.length > 0 && (<Section section={`/movie/sub/search/${term}/`} title={'Movie Results'}>{movieResult.map(i => <Poster key={i.id} id={i.id} imgUrl={i.poster_path} title={i.original_title} rating={i.vote_average} year={i.release_date && i.release_date.substring(0, 4)} isMovie={true} />)}</Section>)}
                {tvResult && tvResult.length > 0 && (<Section section={`/show/sub/search/${term}/`} title={'TV Shows Results'}>{tvResult.map(i => <Poster key={i.id} id={i.id} imgUrl={i.poster_path} title={i.original_name} rating={i.vote_average} year={i.first_air_date && i.first_air_date.substring(0, 4)} isMovie={false} />)}</Section>)}
                {error && <Error data={'No Data'} />}
                {movieResult && tvResult && movieResult.length === 0 && tvResult.length === 0 && (<Message data={`Nothing found for : ${searchResult}`} />)}
            </>
            }
        </Container >)
}




SearchPresenter.propTypes = {
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string,
    searchTerm: PropTypes.string,
    movieResult: PropTypes.array,
    tvResult: PropTypes.array,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
}



export default SearchPresenter


